module.exports = __webpack_public_path__ + "img/120011.88c06f24.png";